var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning-Circle--Streamline-Core.svg",
    clipPath: "url(#clip0_926_5707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-circle--warning-alert-frame-exclamation-caution-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0003 23.3194C17.7159 23.3194 22.3492 18.6861 22.3492 12.9705C22.3492 7.25496 17.7159 2.62158 12.0003 2.62158C6.28474 2.62158 1.65137 7.25496 1.65137 12.9705C1.65137 18.6861 6.28474 23.3194 12.0003 23.3194Z",
    stroke: "#B71C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 8.19385V13.3683",
    stroke: "#B71C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1111",
    d: "M12.0006 17.7468C11.7807 17.7468 11.6025 17.5685 11.6025 17.3487C11.6025 17.1289 11.7807 16.9507 12.0006 16.9507",
    stroke: "#B71C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1112",
    d: "M12.001 17.7468C12.2208 17.7468 12.399 17.5685 12.399 17.3487C12.399 17.1289 12.2208 16.9507 12.001 16.9507",
    stroke: "#B71C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_5707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.970703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleRed);
export default __webpack_public_path__ + "static/media/warning_circle_red.053a8f43d889a43a2d311987360035d0.svg";
export { ForwardRef as ReactComponent };